/* global deptContextId, deptProcPrEnabled, deptProcEaEnabled, deptProcDirectCommitEnabled, deptProcFetchUrl, deptProcExpensesUrl, deptProcStorePRUrl, deptProcIndexPRUrl,
         deptProcDirectCommitmentUrl, deptProcDirectPurchaseOrderUrl, deptProcRefreshCommitmentDataUrl,
         deptProcSyncProjectsUrl, deptProcFetchDepartmentsUrl, deptProcListUsersUrl,
         deptProcStoreItemUrl, deptProcEventStartDate, deptProcEventEndDate, deptProcChartFetchUrl,
         deptProcDraftsIndexUrl, deptProcDeleteDraftUrl */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ProcurementPlanChart from './ProcurementPlanChart';
import ProcurementPlanIndex from './ProcurementPlanIndex';

import { UsersProvider } from 'Context/UsersContext';

if (document.getElementById('deptProcurementPlan')) {
    var root = document.getElementById('deptProcurementPlan');
    ReactDOM.render(
        <App>
            <UsersProvider fetchUrl={deptProcListUsersUrl}>
                <ProcurementPlanIndex
                    prEnabled={deptProcPrEnabled}
                    eaEnabled={deptProcEaEnabled}
                    directCommitEnabled={deptProcDirectCommitEnabled}
                    fetchUrl={deptProcFetchUrl}
                    expensesUrl={deptProcExpensesUrl}
                    storePRUrl={deptProcStorePRUrl}
                    indexPRUrl={deptProcIndexPRUrl}
                    directCommitmentUrl={deptProcDirectCommitmentUrl}
                    directPurchaseOrderUrl={deptProcDirectPurchaseOrderUrl}
                    refreshCommitmentDataUrl={deptProcRefreshCommitmentDataUrl}
                    syncProcurementPlanProjectsUrl={deptProcSyncProjectsUrl}
                    fetchDepartmentsUrl={deptProcFetchDepartmentsUrl}
                    listUsersUrl={deptProcListUsersUrl}
                    storeProcurementPlanItemUrl={deptProcStoreItemUrl}
                    draftsIndexUrl={deptProcDraftsIndexUrl}
                    deleteDraftUrl={deptProcDeleteDraftUrl}
                    eventEndDate={deptProcEventEndDate}
                    eventStartDate={deptProcEventStartDate}
                    departmentContextId={deptContextId}
                />
            </UsersProvider>
        </App>,
        root,
    );
}

if (document.getElementById('deptProcurementGanttChart')) {
    var ganttRoot = document.getElementById('deptProcurementGanttChart');
    ReactDOM.render(
        <App>
            <ProcurementPlanChart fetchUrl={deptProcFetchUrl} chartDataUrl={deptProcChartFetchUrl} departmentContextId={deptContextId} />
        </App>,
        ganttRoot,
    );
}
